import {
  UserContentDetailsInstitutionModel,
  UserContentDetailsModel
} from '@/domain/models/content/user-content-details-model'

export interface UserContentDetails {
  get(id: number, toEnrollment?: boolean): Promise<UserContentDetails.Model>
}

export namespace UserContentDetails {
  export type Model = UserContentDetailsModel
  export type InstitutionModel = UserContentDetailsInstitutionModel
  export const Key = 'user-content-details'
}
